import { render, staticRenderFns } from "./DisplayPhoneNumber.vue?vue&type=template&id=070ba87a&scoped=true&"
import script from "./DisplayPhoneNumber.vue?vue&type=script&lang=ts&"
export * from "./DisplayPhoneNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070ba87a",
  null
  
)

export default component.exports